var path = '/app/components/ui/abeldo-chroma-dialog-scene/abeldo-chroma-dialog-scene.html';
var html = "<div class=\"abeldo-chroma-dialog-container ng-hide\" ng-show=\"$ctrl.currentScene !== null\"> <div class=scenes ng-repeat=\"scene in $ctrl.scenes\" ng-show=\"$ctrl.currentScene === $index\"> <img ng-src=\"{{ scene.bg }}\"/> <dialog-ballons visible=scene.visible thumb=scene.thumb dialogs=scene.text position=$ctrl.ballonPosition on-close=$ctrl.onCloseBallon()> </dialog-ballons> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/abeldo-chroma-dialog-scene/abeldo-chroma-dialog-scene.html
// module id = 148
// module chunks = 0